var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.9999C5.51095 14.9999 3.60341 14.2098 2.19661 12.8033C0.790141 11.3967 0 9.48922 0 7.49997C0 5.51072 0.790141 3.6034 2.19661 2.1966C3.60321 0.790138 5.51074 0 7.5 0C9.48926 0 11.3966 0.790138 12.8034 2.1966C14.2099 3.60319 15 5.51072 15 7.49997C14.9978 9.48844 14.207 11.3947 12.8009 12.8009C11.3949 14.2069 9.48866 14.9977 7.5 14.9999ZM8.19763 4.01168C8.19763 3.76244 8.06471 3.53212 7.84888 3.4075C7.63304 3.28287 7.36697 3.28287 7.15113 3.4075C6.93528 3.53212 6.80237 3.76244 6.80237 4.01168V7.21129L4.21613 9.79752C4.08146 9.92751 4.00473 10.1062 4.00309 10.2933C4.00145 10.4804 4.07516 10.6604 4.20737 10.7927C4.3397 10.925 4.51968 10.9987 4.70679 10.997C4.8939 10.9954 5.07259 10.9186 5.20259 10.784L7.99323 7.99335C8.12358 7.86219 8.19704 7.68502 8.19763 7.50012L8.19763 4.01168Z",
    fill: "url(#paint0_linear_974_12062)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_974_12062",
    x1: 15,
    y1: 7.5,
    x2: 0,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9F20"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.9206dcbb0588ce1279fd3a442c99a02c.svg";
export { ForwardRef as ReactComponent };